const { produce } = require("immer");

const init = {
  uid: null,
  key: null,
  name: {
    en: null,
    fr: null
  },
  version: null,
  icon: null,
  preview: null
}

module.exports = function (state = init, action) {
  switch(action.type) {
    case "SET_appForm":
      return produce(state, draft => {
        Object.assign(draft, init, action.form);
      });

    case "UPDATE_appForm":
      return produce(state, draft => {
        Object.assign(draft, action.form, {
          name: Object.assign(draft.name, action.form.name)
        });
      });

    case "RESET_appForm":
      return init;

    default:
      return state;
  }
}
